import { useMemo } from 'react'
import { format, addDays, parse } from 'date-fns'
import useBootstrapData from '@/hooks/useBootstrapData'
import type { MultiHotelFormState } from '../../SearchForm/MultiHotelSearchForm/types'
import { getInitialState } from '../../SearchForm/MultiHotelSearchForm/utils'
import type { MultiHotelInitialData } from './types'

const useMultiHotelFormInitialValues = (
  initialData?: MultiHotelInitialData
) => {
  const {
    isMobile,
    webstats: { clientGUID: cguid }
  } = useBootstrapData()

  const initialValues: MultiHotelFormState = useMemo(() => {
    const today = new Date()
    const startDate = initialData?.startDate || format(today, 'yyyyMMdd')
    const startDateParsed = parse(startDate, 'yyyyMMdd', today)
    const endDate =
      initialData?.endDate || format(addDays(startDateParsed, 1), 'yyyyMMdd')
    const endLocation = initialData?.endLocation ?? null

    const baseState = getInitialState(startDate, endDate, endLocation)

    const travelers = initialData?.travelers ?? baseState.travelers

    return {
      ...baseState,
      travelers: {
        adults: travelers.adults,
        children: travelers.children,
        childrenAges: travelers.childrenAges,
        rooms: travelers.rooms,
        lapInfants: 0
      }
    } as MultiHotelFormState
  }, [initialData])

  return {
    initialValues,
    isMobile,
    cguid
  }
}

export default useMultiHotelFormInitialValues
